import { Descriptions, Drawer, Typography } from "@arco-design/web-react";

import { formatNotificationTime } from "../service";
import type { NotificationMessage } from "../types";

interface NotificationDetailDrawerProps {
  message: NotificationMessage | null;
  onClose: () => void;
}

/** 展示普通通知的完整正文，不承载 URL 消息业务处理。 */
export function NotificationDetailDrawer({ message, onClose }: NotificationDetailDrawerProps) {
  return (
    <Drawer
      className="notification-center-detail-drawer"
      width={520}
      visible={Boolean(message)}
      title={message?.title ?? "通知详情"}
      footer={null}
      onCancel={onClose}
      unmountOnExit
    >
      {message ? (
        <div style={{ display: "grid", gap: 20 }}>
          <Descriptions
            column={1}
            data={[
              { label: "消息类型", value: "普通通知" },
              { label: "通知时间", value: formatNotificationTime(message.occurredAt) },
              ...(message.actorNameSnapshot
                ? [{ label: "操作人", value: message.actorNameSnapshot }]
                : []),
            ]}
          />
          {message.summary ? <Typography.Paragraph>{message.summary}</Typography.Paragraph> : null}
          <p className="notification-center-detail__content">
            {message.content || "暂无更多正文内容。"}
          </p>
        </div>
      ) : null}
    </Drawer>
  );
}
